/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['./EmbedMedia', 'text!./YoutubeVideo.html'], function (EmbedMedia, Template) {

	// YouTube Url patterns
	// these formats are also used in the IT Tests. If modified, make sure to update them as well in the file:
	//   dashboard-it -> tests/utilities/Media.js
	const siteFormat = /.*\.youtube\.com\/watch\?v=([A-Za-z0-9-_]+).*/;
	const shortFormat = /.*\/youtu\.be\/([A-Za-z0-9-_]+).*/;
	const embedFormat = /.*\.youtube\.com\/embed\/([A-Za-z0-9-_]+).*/;

	const FORMATS = [siteFormat, shortFormat, embedFormat];

	const getYoutubeId = (url) => {
		let match;
		for (let i = 0; i < FORMATS.length; i++) {
			match = FORMATS[i].exec(url);
			if (match) {
				return match[1];
			}
		}
		return null;
	};

	class YoutubeVideoLoader {

		constructor(type) {
			this.type = type;
		}

		tryToLoad(url) {
			const youtubeId = getYoutubeId(url);
			return youtubeId && new EmbedMedia(url, this.type, Template, {
				youtubeId: youtubeId
			});
		}
	}

	return YoutubeVideoLoader;
});